import { AgeType } from "../api/contracts/reservation";

export interface GuestTypeTotals {
  adult: number;
  teenager: number;
  child: number;
  infant: number;
}

/**
 * Sums guest counts by age type across every unit in a multi-unit search.
 *
 * A collapsed header/summary label describes the whole party across all
 * units — not just the active or last-expanded one. Per-unit surfaces (the
 * open accordion section for a single unit, a cart row for a single room)
 * keep reading a single unit's `guests` directly; this helper is only for
 * call sites that want the total.
 */
export const sumGuestTypesAcrossUnits = (
  units: ReadonlyArray<{ guests: ReadonlyArray<{ ageType: AgeType }> }>,
): GuestTypeTotals => {
  const totals: GuestTypeTotals = {
    adult: 0,
    teenager: 0,
    child: 0,
    infant: 0,
  };
  units.forEach((unit) => {
    unit.guests.forEach((guest) => {
      totals[guest.ageType] += 1;
    });
  });
  return totals;
};

/** An activity search prices one guest mix and shows one group, so the units carried over from a
 *  lodging search shrink to the one the guest has open. */
export const keepActiveUnit = <U extends { id: string }>(units: U[], activeId: string): U[] =>
  units.length > 1 ? [units.find((u) => u.id === activeId) ?? units[0]] : units;
